const T = require("react").PropTypes;

const facilityAuditType = require("./FacilityAudit.js").PropType; 

const DistrictReport = {
    PropType: T.shape({
        Stores: T.arrayOf(facilityAuditType).isRequired
    })
};

module.exports = DistrictReport; 


// WEBPACK FOOTER //
// ./src/types/DistrictReport.js